import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';

import Formsy from 'formsy-react';
import { Row, Col, Button, FormGroup, Label, SheetFooter, SheetBody, DatePickerPreset } from 'twyne-new.ui';

import { TODAY } from 'components/DateRangeButton';
import Input from 'components/form/Input';
import history from 'utils/history';

import { useDataExtractorStore } from '../store';

import Fields from './Fields';

const propTypes = {
  handleSubmit: PropTypes.func,
}

function Form({ handleSubmit }) {
  const { lists: { customFields: { items, useLoad } } } = useDataExtractorStore()
  const [mergetags, setMergetags] = useState([])
  const [fields, setFields] = useState([])
  const [startAt, setStartAt] = useState(TODAY.start)
  const [endAt, setEndAt] = useState(TODAY.end)

  useLoad()

  useEffect(() => {
    if (items?.length) {
      const fields = items.filter(field => !field.private).map(({ key }) => `cf_${key}`)
      setMergetags([...USER, ...fields])
    }
  }, [items])

  const handleValidSubmit = useCallback(model => {
    model.fields = fields.map(({ key, value }) => ({ key, value }))
    handleSubmit({ ...model, startAt, endAt })
  }, [fields, startAt, endAt, handleSubmit])

  const handleChange = useCallback(searchDates => {
    setStartAt(searchDates?.$gte)
    setEndAt(searchDates?.$lte)
  }, [])

  return <Formsy onValidSubmit={handleValidSubmit}>
    <SheetBody>
      <Row>
        <Col size="6">
          <FormGroup>
            <Label>Date Range</Label>
            <DatePickerPreset
              value={startAt && { $gte: startAt, $lte: endAt }}
              onChange={handleChange}
              preset={false}
            />
          </FormGroup>
        </Col>
        <Col size="6">
          <FormGroup>
            <Label>Zip Password</Label>
            <Input required type="password" name="credential" value={""} />
          </FormGroup>
        </Col>
        <Col size="12">
          <Fields mergetags={mergetags} fields={fields} onChange={setFields} />
        </Col>
      </Row>
    </SheetBody>
    <SheetFooter>
      <Button onClick={() => history.goBack()} variant="ghost">Cancel</Button>
      <Button type="submit" color="accent">Save</Button>
    </SheetFooter>
  </Formsy>
}

Form.propTypes = propTypes;

export default Form;

const USER = [
  'first_name',
  'last_name',
  'email',
  'address1',
  'address2',
  'city',
  'state',
  'zip',
  'country',
  'phone',
  'dob',
  'gender',
  'lastRegistration',
]
